import { DASHBOARD_TOUR } from './definitions/dashboard.tour'
import EVENT_PAGE_TOUR from './definitions/event-page.tour'
import REGISTRATION_SETTINGS_TOUR from './definitions/registration-settings.tour'
import ORDERS_TOUR from './definitions/orders.tour'
import LIVE_REGISTRATIONS_TOUR from './definitions/live-registrations.tour'
import VOLUNTEER_SETTINGS_TOUR from './definitions/volunteer-settings.tour'
import VOLUNTEER_APPLICATIONS_TOUR from './definitions/volunteer-applications.tour'
import SPECTATOR_SETTINGS_TOUR from './definitions/spectator-settings.tour'
import SPECTATOR_ORDERS_TOUR from './definitions/spectator-orders.tour'
import EMAIL_SEND_TOUR from './definitions/email-send.tour'
import EMAIL_HISTORY_TOUR from './definitions/email-history.tour'
import CONTRACT_SETTINGS_TOUR from './definitions/contract-settings.tour'
import CONTRACT_REPORTS_TOUR from './definitions/contract-reports.tour'
import CHECK_IN_TOUR from './definitions/check-in.tour'
import SCORE_MANAGEMENT_TOUR from './definitions/score-management.tour'
import TV_VIEW_TOUR from './definitions/tv-view.tour'
import CLAIMS_TOUR from './definitions/claims.tour'
import PLANNING_SETTINGS_TOUR from './definitions/planning-settings.tour'
import PLANNING_STREAM_TOUR from './definitions/planning-stream.tour'
import LIVE_SETTINGS_TOUR from './definitions/live-settings.tour'
import HOME_TOUR from './definitions/home.tour'
import MY_EVENTS_TOUR from './definitions/my-events.tour'

/**
 * The page tours (lot 2, 28 Oct 2026), in side-menu order. Each one carries `paths`: the routes it
 * plays on, relative to the event root ('' = the hub root; a tour may serve several routes — the
 * athlete and volunteer contract pages, the three check-in pages, the hub tabs). No tour for the
 * admin-only External API page nor for « Qualified list », still on the legacy interface.
 */
export const PAGE_TOURS = [
    EVENT_PAGE_TOUR,
    REGISTRATION_SETTINGS_TOUR,
    ORDERS_TOUR,
    LIVE_REGISTRATIONS_TOUR,
    VOLUNTEER_SETTINGS_TOUR,
    VOLUNTEER_APPLICATIONS_TOUR,
    SPECTATOR_SETTINGS_TOUR,
    SPECTATOR_ORDERS_TOUR,
    EMAIL_SEND_TOUR,
    EMAIL_HISTORY_TOUR,
    PLANNING_SETTINGS_TOUR,
    PLANNING_STREAM_TOUR,
    LIVE_SETTINGS_TOUR,
    SCORE_MANAGEMENT_TOUR,
    TV_VIEW_TOUR,
    CLAIMS_TOUR,
    CHECK_IN_TOUR,
    CONTRACT_SETTINGS_TOUR,
    CONTRACT_REPORTS_TOUR,
].filter(Boolean)

/**
 * The site tours (29 Oct 2026): pages outside the organizer shell, on absolute `routes` — the home page
 * (search) and « My events » (roles, per-role actions). Played by the site host mounted in App.js,
 * offered by the same invitation card, replayed from the account menu's « Guided tour » row.
 */
export const SITE_TOURS = [HOME_TOUR, MY_EVENTS_TOUR]

/** Every guided tour by id: the dashboard tour (side menu), one tour per organizer page, the site tours. */
export const TOURS = Object.fromEntries([DASHBOARD_TOUR, ...PAGE_TOURS, ...SITE_TOURS].map((tour) => [tour.id, tour]))

export const getTour = (id) => TOURS[id] || null

const cleanPath = (rel) => String(rel || '').replace(/^\/+|\/+$/g, '')

/** The page tour of a relative organizer path (`shell.rel`), or null when the page has none. */
export const tourForPath = (rel) => {
    const path = cleanPath(rel)
    return PAGE_TOURS.find((tour) => (tour.paths || []).some((candidate) => cleanPath(candidate) === path)) || null
}

/** The site tour of an absolute pathname ('/', '/my-events'), or null. */
export const tourForRoute = (pathname) => {
    const path = cleanPath(pathname)
    return SITE_TOURS.find((tour) => (tour.routes || []).some((route) => cleanPath(route) === path)) || null
}
